import { type DeepLinkSchema } from '~/domains/platform/infra/deep-link/entities'

export const BANKING_ROUTES = [
  '/extrato',
  '/extrato/agendado',
  '/extrato/agendamentos',
  '/extrato/agendamentos/${schedulingId}/cancelar',
  '/pagar',
  '/boletos',
  '/pagar/boleto',
  '/pagar/boleto/inserir-codigo',
  '/pagar/boleto/confirmar-dados',
  '/pagar/boleto/finalizar',
  '/pagar/boleto/sucesso',
  // criar boleto
  '/criar/boleto/valor',
  '/criar/boleto/selecionar-tipo-de-boleto',
  '/criar/boleto/adicionar-descricao',
  '/criar/boleto/dados-do-pagador',
  '/criar/boleto/confirmar-dados',
  '/criar/boleto/cadastrar-endereco',
  '/criar/boleto/buscar-cep',
  '/criar/boleto/personalizar-o-boleto',
  '/criar/boleto/taxas',
  '/criar/boleto/feedback',
  '/criar/boleto/novo-feedback',
  '/criar/boleto/metodo',
  '/criar/boleto/enviar-email',
  // detalhes do boleto
  '/boleto/detalhes-do-boleto',
  '/boletos/detalhes-do-boleto/${id}',
  '/boletos/detalhes-do-boleto/recorrencia/${id}',
  '/boletos/detalhes-do-boleto/parcelado/${id}',
  // gerenciar boletos
  '/boletos/gerenciar/recorrencia',
  '/boletos/gerenciar/parcelado',
  // DDA
  '/dda',
  '/meu-dda/dda/pin',
  '/meu-dda/dda/erro',
  '/meu-dda/dda/ativado-com-sucesso',
  '/meu-dda/dda/desativado-com-sucesso',
  '/meu-dda/dda/erro-ao-desativar',
  '/meu-dda/dda/pin-desativar',
  // pagamento sem código de barras
  '/pagar/tributos',
  '/pagar/tributos/${type}',
  '/pagar/tributos/${type}/preencher-dados',
  '/pagar/tributos/${type}/revisar-dados',
  '/pagar/tributos/${type}/finalizar',
  '/pagar/tributos/${type}/sucesso',
  '/pagar/tributos/${type}/ocr',
  '/pagar/tributos/${type}/selecionar-metodo',
  // pix
  '/pix',
  '/pix/minhas-chaves',
  '/pix/minhas-chaves/pedidos-de-chaves',
  '/pix/minhas-chaves/resumo',
  '/pix/pagar/inserir-qr-code',
  '/pix/pagar/inserir-senha',
  '/pix/pagar/confirmar-dados',
  '/pix/pagar/inserir-valor-qr-code',
  '/pix/pagar/responder-recebedor',
  '/pix/pagar/calendario',
  '/pix/devolucao',
  '/pix/devolucao/confirmar',
  '/pix/devolucao/inserir-senha',
  '/pix/devolucao/inserir-valor',
  '/pix/pagar/inserir-valor-qr-code',
  '/pix/pagar/responder-recebedor',
  // pix qr code
  '/gerar-qr-code/inserir-valor-do-qr-code',
  '/gerar-qr-code/tipo-de-vencimento',
  '/gerar-qr-code/data-de-vencimento',
  '/gerar-qr-code/adicionar-desconto',
  '/gerar-qr-code/informar-desconto',
  '/gerar-qr-code/dados-do-pagador',
  '/gerar-qr-code/confirmar-dados',
  '/gerar-qr-code/qr-code-gerado',
  // pix em lote v2
  '/pix-em-lote',
  '/pix-em-lote/pagar',
  '/pix-em-lote/pagar/revisar-pagamento',
  '/pix-em-lote/pagar/confirmar-pagamento',
  '/pix-em-lote/transacoes/rascunhos',
  '/pix-em-lote/transacoes/${id}/detalhes',
  // pagamento em lote
  '/pagamento-em-lote/boleto',
  '/pagamento-em-lote/confirmar',
  // contatos
  '/contatos/meus-contatos',
  '/contatos/adicionar-contato',
  '/contatos/salvar-contato',
  '/contatos/detalhes',
  '/contatos/editar-contato',
  '/contatos/contato-confiavel',
  '/contatos/adicionar-conta',
  '/contatos/salvar-conta',
  // contatos-v2
  '/contatos-v2',
  '/contatos-v2/${id}',
  '/contatos-v2/${id}/editar-dados',
  '/contatos-v2/${id}/editar-grupos',
  '/contatos-v2/${id}/editar-grupos',
  '/contatos-v2/${id}/adicionar-conta/${step}',
  '/contatos-v2/onboarding',
  '/contatos-v2/criar-contato/${step}',
  //transfer
  '/transferir/dados-recebedor',
  '/transferir/selecione-contato',
  '/transferir/dados-recebedor-v2',
  '/transferir/dados-da-transferência',
  '/transferir/dados-da-transferência-v2',
  '/transferir/confirmar-transferência',
  '/transferir/confirmar-transferência-v2',
  //transactional limits
  '/limites-transacionais',
  '/limites-transacionais/detalhes',
  '/limites-transacionais/alterar-limite/inserir-valor',
  '/limites-transacionais/alterar-limite/inserir-senha',
  '/limites-transacionais/periodo-diurno/alterar-periodo-diurno',
  '/limites-transacionais/periodo-diurno/inserir-senha',
  '/limites-transacionais/detalhes?operation=outbound_pix_payment',
  //abertura de conta
  '/criar-conta',
  //saque automatico
  '/saque-automatico',

  // open finance
  '/open-finance',
  // open finance pagamento
  '/open-finance/pagamento',
  '/open-finance/pagamento-v2',
  '/open-finance/pagamento-jsr',
  '/open-finance/meus-pagamentos',
  '/open-finance/meus-pagamentos/inserir-senha',
  '/open-finance/meus-pagamentos/confirmar-cancelamento',
  // open finance pagamento
  '/open-finance/meus-pagamentos',
  '/open-finance/meus-pagamentos/inserir-senha',
  '/open-finance/meus-pagamentos/confirmar-cancelamento',
  // open finance novo consentimento
  '/open-finance/novo-consentimento',
  '/open-finance/novo-consentimento/suas-informacoes',
  '/open-finance/novo-consentimento/trazer-dados',
  '/open-finance/novo-consentimento/confirmacao',
  '/open-finance/novo-consentimento/compartilhamento-completo',
  '/open-finance/novo-consentimento/solicitacao-consentimento',
  '/open-finance/novo-consentimento/redirecionamento',
  '/open-finance/novo-consentimento/compartilhamento-incompleto',
  '/open-finance/novo-consentimento/feedback',

  // open finance compartilhar dados
  '/open-finance/compartilhar-dados',
  '/open-finance/compartilhar-dados/selecionar-conta',
  '/open-finance/compartilhar-dados/confirmacao',
  '/open-finance/compartilhar-dados/redirecionamento',

  // open finance meus compartilhamentos
  '/open-finance/meus-compartilhamentos',
  '/open-finance/meus-compartilhamentos/compartilhamentos',
  '/open-finance/meus-compartilhamentos/detalhes-compartilhamento',
  '/open-finance/meus-compartilhamentos/sucesso-cancelamento',
  '/open-finance/meus-compartilhamentos/confirmacao',
  '/open-finance/meus-compartilhamentos/redirecionamento',

  // open finance iniciacao pagamento
  '/open-finance/iniciacao-pagamento',
  '/open-finance/iniciacao-pagamento/valor-transacao',
  '/open-finance/iniciacao-pagamento/escolha-instituicao',
  '/open-finance/iniciacao-pagamento/confirmar-transacao',
  '/open-finance/iniciacao-pagamento/redirecionamento',
  '/open-finance/iniciacao-pagamento/feedback',
  '/open-finance/iniciacao-pagamento/sucesso',
  '/open-finance/iniciacao-pagamento/erro',

  // open finance canais de atendimento
  '/open-finance/canais-atendimento',

  // open finance canais de atendimento
  '/open-finance/agendamentos-recorrentes',
  '/open-finance/agendamentos-recorrentes/listagem',
  '/open-finance/agendamentos-recorrentes/detalhes',
  '/open-finance/agendamentos-recorrentes/historico',
  '/open-finance/agendamentos-recorrentes/sucesso',

  //redirecionamento deeplink mobile open finance
  '/open-finance/redirecionamento-deeplink',

  //link de pagamento
  '/link-de-pagamento',
  '/link-de-pagamento/criar',
  '/link-de-pagamento/${paymentLinkId}',
  '/link-de-pagamento/v2',
  '/link-de-pagamento/v2/criar',
  '/link-de-pagamento/v2/detalhes/${paymentLinkId}',
  //agenda
  '/agenda-financeira',
  //saque
  '/saque',
  '/saque/token',
  '/saque/token/criar',
  '/saque/token/criar/confirmar',
  '/saque/token/criar/dados-do-saque',

  //minhas finanças
  '/minhas-financas',
  '/minhas-financas/categorias',
  '/minhas-financas/categorias/extrato/${categoryPathName}',
  '/minhas-financas/categorias/extrato/${categoryPathName}/alterar-categoria/${transactionId}',

  //folha de pagamento (funcionários)
  '/folha-de-pagamento',
  '/funcionarios',
  '/funcionarios/pagar',
  '/funcionarios/pagar/confirmar-pagamento/${paymentId}',
  '/funcionarios/pagar/confirmar-senha/${paymentId}',
  '/funcionarios/pagamentos/rascunhos',
  '/funcionarios/bate-ponto',
  '/funcionarios/bate-ponto/contratar',
  '/funcionarios/bate-ponto/configuracao/preparar',
  '/funcionarios/bate-ponto/configuracao/inicio',
  '/funcionarios/bate-ponto/configuracao/app',
  '/funcionarios/bate-ponto/configuracao/token',
  '/funcionarios/bate-ponto/configuracao/revisar',
  '/funcionarios/bate-ponto/configuracao/maquininha-l4',
  '/funcionarios/bate-ponto/configuracao/baixar-app-e-token',
  '/funcionarios/bate-ponto/configuracao/configurar-bate-ponto',
  '/funcionarios/planos',
  '/funcionarios/planos/bate-ponto-e-pagar-e-conta-funcionario',
  '/funcionarios/planos/bate-ponto-e-pagar',
  '/funcionarios/planos/bate-ponto-e-pagar/atualizar',
  '/funcionarios/planos/bate-ponto',
  '/funcionarios/planos/pagar',
  '/funcionarios/planos/pagar-conta-ton',
  '/funcionarios/bate-ponto/como-bater-ponto/configurar',
  '/funcionarios/bate-ponto/como-bater-ponto/iniciar-app',
  '/funcionarios/bate-ponto/como-bater-ponto/reconhecimento-facial',
  '/funcionarios/bate-ponto/como-bater-ponto/informe-cpf',
  '/funcionarios/bate-ponto/como-bater-ponto/ponto-batido',
  '/funcionarios/plano-contratado',
  '/funcionarios/cancelar-plano/beneficios',
  '/funcionarios/cancelar-plano/confirmar',
  '/funcionarios/detalhes-do-pagamento/${paymentId}',
  '/funcionarios/gerenciar',

  // payroll without l4
  '/funcionarios/bate-ponto/sem-l4/aviso',
  '/funcionarios/bate-ponto/sem-l4/pesquisa',
  '/funcionarios/bate-ponto/sem-l4/horario-de-funcionamento',
  '/funcionarios/bate-ponto/sem-l4/revisar',

  //recorrencias
  '/recorrencias',
  '/cancelar-recorrencia/agendamentos',
  '/cancelar-recorrencia/inserir-senha',
  '/cancelar-recorrencia/feedback',

  // kyc onboarding
  '/stone-account/kyc/redirect-onboarding'
] as const

export const bankingDeepLinks: { [key: string]: DeepLinkSchema } = {
  '/deeplink/open-finance/pagamento': {
    url: '/open-finance/pagamento',
    type: 'products',
    product: 'opf',
    requiresLogin: true
  },
  '/deeplink/open-finance/pagamento-v2': {
    url: '/open-finance/pagamento-v2',
    type: 'products',
    product: 'opf',
    requiresLogin: true
  },
  '/deeplink/open-finance/pagamento-jsr': {
    url: '/open-finance/pagamento-jsr',
    type: 'products',
    product: 'opf',
    requiresLogin: true
  },
  '/deeplink/open-finance/compartilhar-dados': {
    url: '/open-finance/compartilhar-dados',
    type: 'products',
    product: 'opf',
    requiresLogin: true
  },
  '/deeplink/open-finance/novo-consentimento/feedback': {
    url: '/open-finance/novo-consentimento/feedback',
    type: 'products',
    product: 'opf',
    requiresLogin: true
  },
  '/deeplink/stone-account/kyc/redirect-onboarding': {
    url: '/stone-account/kyc/redirect-onboarding',
    type: 'products',
    product: 'kyc-onboarding',
    requiresLogin: true
  }
}
